// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--l_1Sg","visible-part":"_6c97079b1b--visible-part--2a0SX","hidden-part":"_6c97079b1b--hidden-part--rpVGG"};